(function () {
  'use strict';

  if (window.cwsVariantDefaultSelectionLoaded) return;
  window.cwsVariantDefaultSelectionLoaded = true;

  const pickerSelector = '.x-variant-picker';

  function readVariants(picker) {
    const data = picker.querySelector('script[type="application/json"]');
    if (!data) return [];

    try {
      const variants = JSON.parse(data.textContent);
      return Array.isArray(variants) ? variants : [];
    } catch (error) {
      return [];
    }
  }

  function matchesExistingSelections(variant, groups) {
    return groups.every((group) => {
      const checked = group.querySelector('input[type="radio"]:checked');
      if (!checked) return true;

      const optionIndex = Number(group.dataset.optionIndex);
      return String(variant.options?.[optionIndex] ?? '') === checked.value;
    });
  }

  function findTargetVariant(picker, variants, groups) {
    const radio = picker.querySelector('fieldset[data-option-index] input[type="radio"]');
    const formId = radio?.getAttribute('form');
    const formVariantId = formId
      ? document.getElementById(formId)?.querySelector('input[name="id"]')?.value
      : null;
    const urlVariantId = new URLSearchParams(window.location.search).get('variant');
    const availableMatches = variants.filter((variant) => {
      return variant.available && matchesExistingSelections(variant, groups);
    });

    return availableMatches.find((variant) => String(variant.id) === urlVariantId)
      || availableMatches.find((variant) => String(variant.id) === formVariantId)
      || availableMatches[0]
      || null;
  }

  function repairPicker(picker) {
    const groups = Array.from(picker.querySelectorAll('fieldset[data-option-index]')).filter((group) => {
      return group.querySelector('input[type="radio"]');
    });
    const missingGroups = groups.filter((group) => {
      return !group.querySelector('input[type="radio"]:checked');
    });

    if (!missingGroups.length) return;

    const variants = readVariants(picker);
    const targetVariant = findTargetVariant(picker, variants, groups);
    if (!targetVariant) return;

    const repairedInputs = [];
    missingGroups.forEach((group) => {
      const optionIndex = Number(group.dataset.optionIndex);
      const expectedValue = String(targetVariant.options?.[optionIndex] ?? '');
      const input = Array.from(group.querySelectorAll('input[type="radio"]')).find((candidate) => {
        return !candidate.disabled && candidate.value === expectedValue;
      });

      if (!input) return;

      input.checked = true;
      repairedInputs.push(input);
    });

    repairedInputs.forEach((input) => {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function repairPickers(root) {
    const pickers = root.matches?.(pickerSelector)
      ? [root]
      : Array.from(root.querySelectorAll?.(pickerSelector) || []);

    pickers.forEach(repairPicker);
  }

  function scheduleRepair(root) {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => repairPickers(root || document));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleRepair(document), { once: true });
  } else {
    scheduleRepair(document);
  }

  document.addEventListener('alpine:initialized', () => scheduleRepair(document), { once: true });
  document.addEventListener('shopify:section:load', (event) => scheduleRepair(event.target));
  window.addEventListener('pageshow', () => scheduleRepair(document));
})();
